jQuery(function () {
  // Fonction pour mettre à jour le décompteur
  function updateCountdown() {
    const targetDate = new Date("November 14, 2023 12:00:00 GMT+0100"); // Mettez l'année, le mois, le jour et l'heure cibles ici, ainsi que le fuseau horaire
    const now = new Date();
    const diffInSeconds = Math.floor((targetDate - now) / 1000);

    if (diffInSeconds < 0) {
      $("#compteur").text("Le temps est écoulé !");
      return;
    }

    const days = Math.floor(diffInSeconds / 86400);
    const hours = Math.floor((diffInSeconds % 86400) / 3600);
    const minutes = Math.floor((diffInSeconds % 3600) / 60);
    const seconds = diffInSeconds % 60;

    $("#compteur").text(
      `${days} jours, ${hours} h, ${minutes} min, ${seconds} sec`
    );
  }

  // Mettre à jour le décompteur immédiatement
  updateCountdown();

  // Mettre à jour le décompteur chaque seconde
  setInterval(updateCountdown, 1000);
});
